var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g2, _path1, _path10, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg404 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 200,
    viewBox: "0 0 301 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6152 43.1055C25.6152 42.0009 26.5107 41.1055 27.6152 41.1055L197.203 41.1055V113.915C197.203 114.713 197.677 115.435 198.41 115.751L299.293 159.308C300.026 159.624 300.5 160.346 300.5 161.144V199.498H187.501L26.7345 120.64C26.0494 120.304 25.6152 119.607 25.6152 118.844V43.1055Z",
    fill: "url(#paint0_linear_5682_121489)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.748 1.75977L24.779 26.9635V119.05L97.9109 93.8465L98.748 1.75977Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4473 1.75977L196.542 24.452V116.539L98.4473 93.8465V1.75977Z",
    fill: "#ABABAB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5682_121489)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4083 6.18951C95.4083 6.18951 117.003 15.2146 117.09 22.3516C117.168 28.7351 100.858 37.0458 95.7393 33.2305C90.0168 28.9648 95.4083 6.18951 95.4083 6.18951Z",
    fill: "url(#paint1_linear_5682_121489)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5419 12.3392C98.5419 12.3392 109.69 16.9985 109.735 20.683C109.776 23.9785 101.355 28.269 98.7128 26.2993C95.7584 24.0971 98.5419 12.3392 98.5419 12.3392Z",
    fill: "#FBA581"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.998 6.18951C148.998 6.18951 127.403 15.2146 127.316 22.3516C127.238 28.7351 143.548 37.0458 148.667 33.2305C154.389 28.9648 148.998 6.18951 148.998 6.18951Z",
    fill: "url(#paint2_linear_5682_121489)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.066 12.3392C146.066 12.3392 134.917 16.9985 134.872 20.683C134.832 23.9785 143.252 28.269 145.895 26.2993C148.849 24.0971 146.066 12.3392 146.066 12.3392Z",
    fill: "#FBA581"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.533,
    cy: 43.2673,
    rx: 35.7184,
    ry: 25.4391,
    fill: "url(#paint3_linear_5682_121489)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.239 26.5723C112.331 25.6966 112.585 23.2858 112.585 23.2858",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.459 26.8519C108.363 26.2489 107.932 23.5275 107.932 23.5275",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.284 26.5899C132.192 25.7142 131.939 23.3033 131.939 23.3033",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.065 26.8695C136.16 26.2665 136.591 23.5451 136.591 23.5451",
    stroke: "white",
    strokeWidth: 1.46625,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.356 19.4637C113.356 19.4637 117.134 16.2549 122.899 14.2315C121.304 15.7834 119.75 16.7399 119.632 19.9392C119.513 23.1384 113.356 19.4637 113.356 19.4637Z",
    fill: "#FFD29F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.381 17.8055C118.381 17.8055 122.998 16.0013 129.107 15.9651C127.094 16.9132 125.313 17.3117 124.16 20.2981C123.007 23.2845 118.381 17.8055 118.381 17.8055Z",
    fill: "#FFD29F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1203 31.418C95.1203 31.418 90.8565 33.9448 87.0664 38.7371C89.053 37.7343 90.4634 36.5764 93.5268 37.5061C96.5903 38.4359 95.1203 31.418 95.1203 31.418Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1535 35.9668C93.1535 35.9668 88.8897 38.4937 85.0996 43.2859C87.0862 42.2832 88.4966 41.1252 91.56 42.055C94.6235 42.9847 93.1535 35.9668 93.1535 35.9668Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0627 38.9348C94.0627 38.9348 85.927 42.0474 84.7816 49.8955C86.9784 46.8733 88.5285 45.6918 93.3467 45.9344C98.1648 46.1771 94.0627 38.9348 94.0627 38.9348Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0376 46.0143C88.0376 46.0143 85.313 50.1546 84.0073 56.1233C85.3533 54.3512 86.1133 52.6922 89.2743 52.1849C92.4353 51.6776 88.0376 46.0143 88.0376 46.0143Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2622 50.9645C88.2622 50.9645 85.5376 55.1048 84.2319 61.0735C85.5779 59.3014 86.3379 57.6424 89.4989 57.1351C92.6599 56.6278 88.2622 50.9645 88.2622 50.9645Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3809 53.2336C90.3809 53.2336 84.4331 59.5977 86.8441 67.1536C87.4936 63.4742 88.3689 61.7328 92.8058 59.8387C97.2427 57.9446 90.3809 53.2336 90.3809 53.2336Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7219 48.3198C98.7219 48.3198 98.174 53.2458 99.7203 59.1567C100.115 56.9667 100.039 55.1435 102.625 53.2564C105.211 51.3693 98.7219 48.3198 98.7219 48.3198Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.171 52.6275C101.171 52.6275 100.623 57.5534 102.17 63.4643C102.564 61.2743 102.488 59.4511 105.074 57.564C107.661 55.6769 101.171 52.6275 101.171 52.6275Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.09 53.6876C104.09 53.6876 101.68 62.0583 107.258 67.6962C106.166 64.1229 106.156 62.174 109.249 58.472C112.343 54.77 104.09 53.6876 104.09 53.6876Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.582 61.047C105.582 61.047 107.491 65.621 111.709 70.0411C110.992 67.9343 110.042 66.3765 111.389 63.4722C112.736 60.568 105.582 61.047 105.582 61.047Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.814 63.627C109.814 63.627 111.723 68.201 115.941 72.6212C115.225 70.5143 114.274 68.9566 115.621 66.0523C116.968 63.148 109.814 63.627 109.814 63.627Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.881 63.1412C112.881 63.1412 114.831 71.631 122.444 73.8574C119.756 71.2614 118.802 69.562 119.713 64.8245C120.624 60.087 112.881 63.1412 112.881 63.1412Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.493 31.418C149.493 31.418 153.757 33.9448 157.547 38.7371C155.56 37.7343 154.15 36.5764 151.086 37.5061C148.023 38.4359 149.493 31.418 149.493 31.418Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.46 35.9668C151.46 35.9668 155.724 38.4937 159.514 43.2859C157.527 42.2832 156.117 41.1252 153.053 42.055C149.99 42.9847 151.46 35.9668 151.46 35.9668Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.551 38.9348C150.551 38.9348 158.686 42.0474 159.832 49.8955C157.635 46.8733 156.085 45.6918 151.267 45.9344C146.448 46.177 150.551 38.9348 150.551 38.9348Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.574 46.0143C156.574 46.0143 159.298 50.1546 160.604 56.1233C159.258 54.3512 158.498 52.6922 155.337 52.1849C152.176 51.6776 156.574 46.0143 156.574 46.0143Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.349 50.9645C156.349 50.9645 159.074 55.1048 160.379 61.0735C159.033 59.3014 158.273 57.6424 155.112 57.1351C151.951 56.6278 156.349 50.9645 156.349 50.9645Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.23 53.2336C154.23 53.2336 160.178 59.5977 157.767 67.1536C157.118 63.4742 156.242 61.7328 151.806 59.8387C147.369 57.9446 154.23 53.2336 154.23 53.2336Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.897 48.3198C148.897 48.3198 149.445 53.2458 147.899 59.1567C147.504 56.9667 147.58 55.1435 144.994 53.2564C142.408 51.3693 148.897 48.3198 148.897 48.3198Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.448 52.6275C146.448 52.6275 146.996 57.5534 145.45 63.4643C145.055 61.2743 145.131 59.4511 142.545 57.564C139.959 55.6769 146.448 52.6275 146.448 52.6275Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.529 53.6876C143.529 53.6876 145.94 62.0583 140.361 67.6962C141.453 64.1229 141.463 62.174 138.37 58.472C135.277 54.77 143.529 53.6876 143.529 53.6876Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.037 61.044C142.037 61.044 140.128 65.618 135.91 70.0382C136.627 67.9313 137.577 66.3736 136.23 63.4693C134.883 60.565 142.037 61.044 142.037 61.044Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.805 63.6241C137.805 63.6241 135.896 68.1981 131.678 72.6182C132.394 70.5114 133.345 68.9536 131.998 66.0494C130.651 63.1451 137.805 63.6241 137.805 63.6241Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.738 63.1383C134.738 63.1383 132.788 71.628 125.176 73.8545C127.863 71.2585 128.817 69.5591 127.906 64.8215C126.995 60.084 134.738 63.1383 134.738 63.1383Z",
    fill: "#FFC083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.027 36.2443C118.027 39.8672 115.063 42.8172 111.39 42.8172C107.718 42.8172 104.754 39.8672 104.754 36.2443C104.754 32.6215 107.718 29.6715 111.39 29.6715C115.063 29.6715 118.027 32.6215 118.027 36.2443Z",
    fill: "white",
    stroke: "#E5AB74",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.098 37.8296C109.643 35.3031 113.535 35.2611 114.242 37.8296",
    stroke: "#767676",
    strokeWidth: 1.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.311 36.2443C140.311 39.8672 137.346 42.8172 133.674 42.8172C130.001 42.8172 127.037 39.8672 127.037 36.2443C127.037 32.6215 130.001 29.6715 133.674 29.6715C137.346 29.6715 140.311 32.6215 140.311 36.2443Z",
    fill: "white",
    stroke: "#E5AB74",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.381 37.8296C131.926 35.3031 135.818 35.2611 136.526 37.8296",
    stroke: "#767676",
    strokeWidth: 1.56,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.068,
    cy: 45.9093,
    rx: 2.08737,
    ry: 1.81555,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.08737,
    ry: 1.81555,
    transform: "matrix(-1 0 0 1 125.151 45.9093)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.264 46.5482C126.102 48.1902 122.562 47.6813 122.719 44.3135",
    stroke: "#E08063",
    strokeWidth: 1.404,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.996 46.5482C119.157 48.1902 122.698 47.6813 122.541 44.3135",
    stroke: "#E08063",
    strokeWidth: 1.404,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.764 44.1067H124.318",
    stroke: "#78625B",
    strokeWidth: 1.404,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.005 47.1068C109.9 47.1068 100.398 47.1068 100.398 47.1068",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.862 49.6333C110.617 49.898 104.996 51.0926 104.996 51.0926",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.715 47.1068C135.821 47.1068 145.322 47.1068 145.322 47.1068",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.858 49.6333C135.104 49.898 140.724 51.0926 140.724 51.0926",
    stroke: "white",
    strokeWidth: 1.38,
    strokeLinecap: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7773 26.874L122.872 49.5663V145.839L24.7773 118.961V26.874Z",
    fill: "url(#paint4_linear_5682_121489)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.63 105.505L40.2832 102.984V100.202L47.0516 82.958L52.0243 81.1445L44.9796 100.997L49.63 101.784V93.9162L54.3264 93.7128V102.579L56.5826 102.96V107.38L54.3264 106.771V111.401L49.63 109.613V105.505Z",
    fill: "url(#paint5_linear_5682_121489)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.673 118.252L86.3262 115.986V113.039L93.0945 95.1632L98.0672 93.5332L91.0226 113.753L95.673 114.46V106.443L100.369 106.26V115.175L102.626 115.518V119.937L100.369 119.39V124.045L95.673 122.438V118.252Z",
    fill: "url(#paint6_linear_5682_121489)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3871 93.619C65.445 92.6238 65.6879 91.7313 66.1161 90.9382C66.5443 90.1402 67.0962 89.4423 67.7721 88.8441C68.448 88.2404 69.2158 87.7603 70.0756 87.4053C70.9355 87.047 71.8252 86.8354 72.7448 86.7736C73.6644 86.7123 74.5373 86.8099 75.3634 87.0691C76.1895 87.3325 76.9083 87.749 77.5199 88.3195C78.1315 88.8955 78.6064 89.6043 78.9446 90.445C79.2828 91.2898 79.423 92.2653 79.3651 93.368L78.3579 112.429C78.3 113.515 78.057 114.454 77.6289 115.242C77.2007 116.026 76.6487 116.665 75.9729 117.16C75.297 117.65 74.5292 117.979 73.6693 118.148C72.8095 118.314 71.9198 118.32 71.0002 118.168C70.0806 118.017 69.2077 117.725 68.3816 117.294C67.5555 116.868 66.8367 116.33 66.2251 115.681C65.6135 115.038 65.1386 114.309 64.8004 113.493C64.4622 112.681 64.322 111.788 64.3799 110.809L65.3871 93.619ZM69.0708 111.337C69.0354 111.957 69.2207 112.498 69.6265 112.961C70.0324 113.427 70.5725 113.705 71.2469 113.794C71.9213 113.884 72.4847 113.747 72.9371 113.383C73.3896 113.017 73.6334 112.512 73.6688 111.87L74.6761 93.4364C74.7114 92.7847 74.5261 92.2492 74.1203 91.8321C73.7144 91.4177 73.1743 91.2228 72.4999 91.2458C71.8256 91.2691 71.2621 91.498 70.8097 91.9303C70.3573 92.3599 70.1134 92.8889 70.078 93.519L69.0708 111.337Z",
    fill: "url(#paint7_linear_5682_121489)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.531 24.3623L122.725 49.566V145.839L196.694 116.449L197.531 24.3623Z",
    fill: "#D2DEE9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.531 24.3623L122.725 49.566V145.839L196.694 116.449L197.531 24.3623Z",
    fill: "url(#paint8_linear_5682_121489)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.22 24.2949L223.373 60.7536L147.67 90.6365L122.524 48.9241L197.22 24.2949Z",
    fill: "#E0E0E1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.277 85.6033L129.939 89.7833L129.335 92.7498L129.553 95.2999L130.099 99.1353L129.456 133.824L130.21 123.034L131.617 122.103L130.606 117.38L130.789 99.1835L130.61 94.6029L131.229 92.8822L130.749 89.8399L130.814 77.2668L130.277 85.6033Z",
    fill: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.864 116.083L135.622 111.393L135.953 94.1051L135.299 99.434L134.782 97.6954L134.956 102.226L134.936 111.309L134.554 114.421L135.059 115.984L135.105 122.265L135.864 116.083Z",
    fill: "#B2B4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.682 126.368L139.052 122.572L138.706 119.847L138.876 117.536L139.271 114.069L139.298 82.4779L139.642 92.3269L139.683 95.5051L139.822 97.488L139.71 114.053L139.792 118.093L139.911 119.805L139.567 122.554L139.451 133.997L138.682 126.368Z",
    fill: "#B2B4B6"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1778 26.0371L0.5 64.1196L95.882 89.6607L123.561 48.73L25.1778 26.0371Z",
    fill: "#E0E0E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5682_121489",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 124,
    height: 64
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1778 26.0371L0.5 64.1196L95.882 89.6607L123.561 48.73L25.1778 26.0371Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5682_121489)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5456 55.2209L52.0475 51.8553L54.1313 49.6594L55.298 47.3814L56.8676 43.8396L75.795 14.7628L69.4376 23.5131L67.7507 23.5576L66.1062 28.0984L56.3081 43.4331L54.0322 47.4123L52.5952 48.5433L51.3906 51.378L44.6725 62.006L49.5456 55.2209Z",
    fill: "#C2C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9594 26.4125L58.6795 30.5181L49.2376 45.0036L52.6164 40.8312L52.1331 42.5794L54.3869 38.6448L59.217 30.9533L61.1903 28.5166L61.5904 26.9235L64.8789 21.5723L60.9594 26.4125Z",
    fill: "#C2C3C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.02 16.1966L61.6949 19.2201L60.5449 21.7139L59.1756 23.5838L57.0033 26.315L40.2399 53.0914L45.1675 44.5567L46.8165 41.8395L47.7496 40.0843L56.6229 26.0954L58.6932 22.6261L59.5007 21.111L61.2484 18.9623L67.4111 9.3194L64.02 16.1966Z",
    fill: "#C2C3C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5682_121489",
    x: 62.0078,
    y: 4.18945,
    width: 120.596,
    height: 111.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0469255 0 0 0 0 0.264214 0 0 0 0 0.449378 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5682_121489"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5682_121489",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5682_121489",
    x1: 299.136,
    y1: 197.547,
    x2: 142.318,
    y2: 121.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5682_121489",
    x1: 101.739,
    y1: -14.7129,
    x2: 85.3953,
    y2: 21.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5682_121489",
    x1: 142.667,
    y1: -14.7129,
    x2: 159.011,
    y2: 21.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5682_121489",
    x1: 94.5356,
    y1: -4.04217,
    x2: 91.0236,
    y2: 36.1317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5682_121489",
    x1: 73.8246,
    y1: 26.874,
    x2: 73.8246,
    y2: 145.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0DFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5682_121489",
    x1: 40.8694,
    y1: 81.6056,
    x2: 36.1621,
    y2: 107.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5682_121489",
    x1: 86.9123,
    y1: 93.9982,
    x2: 82.1278,
    y2: 119.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5682_121489",
    x1: 65.2974,
    y1: 86.4917,
    x2: 57.2399,
    y2: 111.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B86A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5682_121489",
    x1: 160.128,
    y1: 24.3623,
    x2: 160.128,
    y2: 145.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg404);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/404.475231b48c0a0131958c6cd2e5183366.svg";